/**
 * @module services
 */

import axios from 'axios';
import LoaderMobile from "@/services/loaderMobile";

let config = {
  apiServer: window.location.origin,
  debugInfo: false,
  xhrTimeout: 1000 * 180
};
let axiosInstance = axios.create({
  baseURL: config.apiServer + '/MFINWeb/',
  method: 'post',
  timeout: config.xhrTimeout,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json, text/plain, */*',
    mode: 'WEB'
  }
});
axiosInstance.interceptors.request.use(config => {
  LoaderMobile.show();
  return config;
});
axiosInstance.interceptors.response.use(response => {
  LoaderMobile.hide();
  return response;
});

export default axiosInstance;
